import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import { useDispatch } from "react-redux";
import { Tooltip, useBreakpoints } from "@qgiv/core-react";
import { ProcessingButton } from "@qgiv/core-donor";
import ConnectedAddAdditionalParticipantButton from "./ConnectedAddAdditionalParticipantButton";

// -------------------------------------------------------------------------
// NOTE: ToolTip for Additional Registrants Button
//       We want to have a tool tip display on hover of the
//       AddAdditionalParticipantButton when it is disabled. The only way to
//       do that, since the button will be disabled,
//       was to wrap the whole button in <Tooltip>
// -------------------------------------------------------------------------

// Locating the columns that house the add participant button outside of
// the ternary operator ensures that even when additional registrants is
// not enabled the placing of the done button remains consistent.

const SaveAndAddParticipant = ({
    hasClassifications,
    displayAddAdditionalRegistrant,
    additionalParticipantsDisabled,
    disabledToolTipContext = "",
    handleClick,
    controlId,
    updateAddAdditionalParticipantDisabled,
}) => {
    const dispatch = useDispatch();
    const { isSubmitting } = useFormikContext();
    const { isSmallScreen } = useBreakpoints();

    useEffect(() => {
        dispatch(
            updateAddAdditionalParticipantDisabled(
                additionalParticipantsDisabled,
            ),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [additionalParticipantsDisabled]);

    return (
        <>
            <div
                className={`col col--12 ${
                    hasClassifications ? "col--xl-5" : "col--xl-6"
                } ${
                    displayAddAdditionalRegistrant
                        ? ""
                        : "-padding-top--0 -padding-bottom--0"
                }`}
            >
                {/* Only display button if additional registrants is enabled */}
                {displayAddAdditionalRegistrant && (
                    <>
                        {isSubmitting && (
                            <ProcessingButton
                                btnStyle="secondary"
                                spinnerStyle="dark"
                            />
                        )}
                        {!isSubmitting && (
                            // eslint-disable-next-line react/jsx-no-useless-fragment
                            <>
                                {additionalParticipantsDisabled &&
                                !isSmallScreen ? (
                                    <Tooltip
                                        placement="right"
                                        content={disabledToolTipContext}
                                        theme="dark"
                                    >
                                        <ConnectedAddAdditionalParticipantButton
                                            additionalParticipantsDisabled={
                                                additionalParticipantsDisabled
                                            }
                                            handleFormSubmitWithEmailValidation={
                                                handleClick
                                            }
                                            controlId={controlId}
                                        />
                                    </Tooltip>
                                ) : (
                                    <ConnectedAddAdditionalParticipantButton
                                        additionalParticipantsDisabled={
                                            additionalParticipantsDisabled
                                        }
                                        handleFormSubmitWithEmailValidation={
                                            handleClick
                                        }
                                        controlId={controlId}
                                    />
                                )}
                            </>
                        )}
                    </>
                )}
            </div>
            {isSmallScreen && (
                <div className="col col--12 -text--center">
                    <p>
                        <small>{disabledToolTipContext}</small>
                    </p>
                </div>
            )}
        </>
    );
};

SaveAndAddParticipant.propTypes = {
    hasClassifications: PropTypes.bool.isRequired,
    displayAddAdditionalRegistrant: PropTypes.bool.isRequired,
    additionalParticipantsDisabled: PropTypes.bool.isRequired,
    disabledToolTipContext: PropTypes.string,
    handleClick: PropTypes.func.isRequired,
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
    updateAddAdditionalParticipantDisabled: PropTypes.func.isRequired,
};

export default SaveAndAddParticipant;
